module.exports = function cos(arg) {
  //  discuss at: https://locutus.io/php/cos/
  // original by: Onno Marsman (https://twitter.com/onnomarsman)
  //   example 1: Math.ceil(cos(8723321.4) * 10000000)
  //   returns 1: -1812718

  return Math.cos(arg)
}
